import { ISystemEvent } from '@/pages/SystemEvents/systemEvents.types'
import { Fragment } from 'react'
import NotificationCenterCard from '../NotificationCenterCard'
import SeparateLine from '@/shared/Forms/SeparateLine'

interface IProps {
  events: ISystemEvent[]
}

const SystemEventsList = (props: IProps) => {
  return (
    <>
      {props.events.map((item, index) => (
        <Fragment key={item.id}>
          <NotificationCenterCard notification={item} />
          {index !== props.events.length - 1 && <SeparateLine />}
        </Fragment>
      ))}
    </>
  )
}

export default SystemEventsList
